import React, { FC, memo, useCallback, useEffect, useState } from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import BaseIcon from 'src/images/marker-base.png';
import PacaIcon from 'src/images/marker-paca.png';
import LostIcon from 'src/images/marker-lost.png';
import ProspectIcon from 'src/images/marker-prospect.png';
import { LegacyCustomer } from 'src/interfaces/api/Customer';
import { MdOpenInNew as LinkIcon } from '@react-icons/all-files/md/MdOpenInNew';
import { Link } from 'react-router-dom';

interface Props {
  customer?: LegacyCustomer;
}

const icon = new L.Icon({
  iconUrl: BaseIcon,
  iconSize: new L.Point(25, 34),
});

const pacaIcon = new L.Icon({
  iconUrl: PacaIcon,
  iconSize: new L.Point(25, 34),
});

const lostIcon = new L.Icon({
  iconUrl: LostIcon,
  iconSize: new L.Point(25, 34),
});

const prospectIcon = new L.Icon({
  iconUrl: ProspectIcon,
  iconSize: new L.Point(25, 34),
});

const CustomerMarker: FC<Props> = ({ customer }) => {
  const [coordinate, setCoordinate] = useState<string[]>();

  useEffect(() => {
    if (customer?.installationSite?.coordinate) {
      const newCoordinate = customer.installationSite.coordinate.split(' ');
      setCoordinate(newCoordinate);
    }
  }, [customer]);

  const getStateLabel = useCallback((): string => {
    switch (customer?.state || 'unknown') {
      case 'prospect':
        return 'Prospect en cours';
      case 'lost':
        return 'Perdu';
      case 'terminated':
        return 'Résilié';
      case 'customer':
        return 'Client';
      case 'unknown':
      default:
        return 'N/A';
    }
  }, [customer]);

  const getMarkerIcon = useCallback((): L.Icon => {
    switch (customer?.state || 'unknown') {
      case 'prospect':
        return prospectIcon;
      case 'lost':
      case 'terminated':
        return lostIcon;
    }

    if (customer?.agency?.id === 2) {
      return pacaIcon;
    }

    return icon;
  }, [customer]);

  if (!coordinate) {
    return null;
  }

  return (
    <Marker icon={getMarkerIcon()} position={coordinate.reverse()}>
      <Popup style={{ display: 'flex', flexDirection: 'column' }}>
        <Link style={{ display: 'flex' }} to={`/dashboard/customer/${customer?.id}`} target='_blank'>
          <LinkIcon size={15} />
          <strong>{customer?.installationSite?.socialReason || ''}</strong>
        </Link>

        <div>
          <strong>Etat:</strong> {getStateLabel()}
        </div>
        <div>
          <strong>Date de création:</strong> {customer?.dateCreate || 'N/A'}
        </div>
      </Popup>
    </Marker>
  );
};

export default memo(CustomerMarker, (prevProps, nextProps) => prevProps.customer?.id === nextProps.customer?.id);
